import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-311e1af1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-header" }, [
  /*#__PURE__*/_createTextVNode(" Login to "),
  /*#__PURE__*/_createElementVNode("strong", null, "OTC Pro")
], -1))
const _hoisted_3 = {
  class: "mt-3",
  style: {"position":"relative"}
}
const _hoisted_4 = {
  key: 0,
  class: "mt-3 d-flex justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-submit w-100" }, "Sign In")
], -1))
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Forgot your password?")
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Resend Activation link?")
const _hoisted_10 = { class: "need-account-link" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Don't have an account? ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Signup Now")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_modal = _resolveComponent("loading-modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_recaptcha_block = _resolveComponent("recaptcha-block")!
  const _component_status_block = _resolveComponent("status-block")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_login_form_container = _resolveComponent("login-form-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_modal, { enabled: _ctx.loadingShow }, null, 8, ["enabled"]),
    _createVNode(_component_login_form_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Form, { onSubmit: _ctx.signIn }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_Field, {
                type: "text",
                name: "Username",
                class: "form-control mt-3",
                modelValue: _ctx.credentials.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.username) = $event)),
                placeholder: "Email Address or username",
                rules: "required"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                class: "error-message",
                name: "Username"
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Field, {
                  type: "password",
                  name: "Password",
                  class: "form-control",
                  modelValue: _ctx.credentials.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
                  placeholder: "Password",
                  rules: "required"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_font_awesome_icon, {
                  class: "toggle-password-visible",
                  icon: ['fas', 'eye']
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                class: "error-message",
                name: "Password"
              }),
              (_ctx.captchaEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_recaptcha_block, { ref: "recaptcha" }, null, 512)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_5,
              _createVNode(_component_status_block, {
                message: _ctx.errorMessage,
                class: "mt-3"
              }, null, 8, ["message"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  class: "grey-form-link",
                  to: "/password-reset"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "grey-form-link",
                  to: "/resend-activation"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            to: "/signup",
            class: "signup-now-link"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}